import { RecruitingInterviewStatics } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import styles from './style.module.scss';

interface Props {
    examData: RecruitingInterviewStatics | null;
};

export default function RecruitingInterviewSheet(props: Props) {
    const { examData } = props;

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.detail}>
                <div className={styles.header}>
                    <div className={styles.header_bottom}>
                        <span className={styles.header_bottom_item}>
                            Question quantities : {examData?.exam.countQuestions}
                        </span>
                        <span className={styles.header_bottom_item}>
                            Interview time : {(examData?.exam.countQuestions || 0) * 5}’
                        </span>
                    </div>
                </div>
                <div className={styles.section}>
                    {examData?.exam.questions.map((item, indx) =>
                        <div className={styles.section_question}>
                            <span>Question {indx + 1}:</span>
                            <span>{item.question}</span>
                        </div>)}
                </div>
            </div>
        </MotionWrapper>
    )
}
